export default "__VITE_PUBLIC_ASSET__3bc7c876__"